import { createException } from '@/utils/monitoring.utils';

let isScriptLoaded = false;
let isWidgetInitialized = false;

export interface IFreshchatConfig {
  token: string;
  host: string;
  siteId: string;
}

function loadScript(): Promise<void> {
  return new Promise((resolve) => {
    if (isScriptLoaded) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.id = 'freshchat-js-sdk';
    script.src = 'https://wchat.freshchat.com/js/widget.js';
    script.async = true;
    script.onload = () => {
      isScriptLoaded = true;
      resolve();
    };
    script.onerror = (event, source, lineno, colno, error) => {
      createException(error ?? new Error('Failed to load Freshchat script'), {
        extra: { event, source, lineno, colno },
      });
      resolve(); // Resolve even on error to prevent blocking further execution
    };

    document.head.appendChild(script);
  });
}

function initWidget(config: IFreshchatConfig) {
  if (isWidgetInitialized) return;

  // @ts-ignore
  window.fcWidget.init({
    token: config.token,
    host: config.host,
    siteId: config.siteId,
  });

  isWidgetInitialized = true;
}

export async function setupFreshchat(config: IFreshchatConfig) {
  await loadScript();
  if (isScriptLoaded) initWidget(config);
}
